import { render, staticRenderFns } from "./DeclarRecord.vue?vue&type=template&id=3724e1de&scoped=true"
import script from "./DeclarRecord.vue?vue&type=script&lang=js"
export * from "./DeclarRecord.vue?vue&type=script&lang=js"
import style0 from "./DeclarRecord.vue?vue&type=style&index=0&id=3724e1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724e1de",
  null
  
)

export default component.exports